<form (ngSubmit)="onSubmit()" [formGroup]="newsletterForm">
  @if (!submitted()) {
    <div class="w-100">
      <mat-form-field appearance="fill" class="field-round mat-error-background" [subscriptSizing]="'dynamic'">
        <input
          matInput
          [placeholder]="'nieuwsbrief-emailadres-placeholder' | fromDictionary"
          formControlName="email"
          autocomplete="email"
        />

        @if (newsletterForm.get('email')?.invalid && triedSubmitting()) {
          <mat-error class="alert--danger">
            @if (newsletterForm.get('email')?.hasError('required')) {
              {{ 'nieuwsbrief-emailadres-foutmelding-verplicht' | fromDictionary }}
            }
            @if (newsletterForm.get('email')?.hasError('email') && !newsletterForm.get('email')?.hasError('required')) {
              {{ 'nieuwsbrief-emailadres-foutmelding-email' | fromDictionary }}
            }
          </mat-error>
        }
      </mat-form-field>

      @if ('nieuwsbrief-recaptcha-tekst' | fromDictionary: false; as recaptchaText) {
        <div class="fs-body-xxs ps-2 mt-1 fst-italic">
          {{ recaptchaText }}
        </div>
      }
    </div>

    <button type="submit" class="button button--accent">
      <span>{{ 'nieuwsbrief-verzenden-knoptekst' | fromDictionary }}</span>
      @if (loading()) {
        <app-loading-indicator [loading]="true" [type]="'standalone'" />
      }
    </button>
  }

  <!--@if (error()) {
    <app-alert [message]="'nieuwsbrief-form-error' | fromDictionary" [status]="'danger'" />
  }-->
  @if (submitted()) {
    <app-alert [message]="'nieuwsbrief-form-success' | fromDictionary" [status]="'success'" />
  }
</form>
